import entityReducer from "./additionalQuestionEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
